import React from "react";
import LogoDark from "../../Assets/logo/logo.png";
import LogoLight from "../../Assets/logo/logo-light.png";
import { Link } from "react-router-dom";
import { Box } from "@material-ui/core";

const containerStyle = {
  width: "180px",
  height: "100%",
};

const containerLargeStyle = {
  width: "280px",
  height: "100%",
};

const markStyle = {
  width: 32,
  height: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const logoStyle = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

const Logo = ({ variant = "dark", redirect = "/d/home", size = "default" }) => {
  if (size === "mark") {
    return (
      <Link to={redirect}>
        <Box style={markStyle}>
          <img
            src="/favicon.svg"
            alt="Carecentre"
            style={{ width: 28, height: 28 }}
          />
        </Box>
      </Link>
    );
  }

  const source = variant === "light" ? LogoLight : LogoDark;
  const style = size === "large" ? containerLargeStyle : containerStyle;
  return (
    <Link to={redirect}>
      <Box style={style}>
        <img src={source} style={logoStyle} alt="Logo" />
      </Box>
    </Link>
  );
};

export default React.memo(Logo);
